module.exports = __webpack_public_path__ + "img/img30.0e18a319.png";